import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {UserResponseBody} from '@dms/api/shared';

export const userByIdMock: UserResponseBody = {
  id: 'test-user-id',
  firstName: 'John',
  lastName: 'Doe',
  state: 'onboarded',
  email: 'john.doe@example.com',
  phoneNumber: {
    countryCode: 'CZE',
    prefix: '+420',
    number: '123456789',
  },
  roles: [{id: 'ROLE_USER', title: 'ROLE_USER'}],
  createdAt: '2024-01-01T00:00:00.000Z',
  lastActivityAt: '2024-01-01T00:00:00.000Z',
  isAway: false,
  awayChangedAt: null,
};

export const systemUserByIdMock: UserResponseBody = {
  ...userByIdMock,
  id: 'system-user-id',
  email: 'podpora@omnetic.com',
  type: 'system',
};

const getUserByIdResponseInterceptor = (
  server: SetupServerApi,
  mockData: UserResponseBody = userByIdMock
) => server.use(http.get('*/dms/v*/user/:userId', () => HttpResponse.json(mockData)));

export const userApiMock = {
  userByIdMock,
  systemUserByIdMock,
  getUserByIdResponseInterceptor,
};
